var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendToContentBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3 30.8485C2.63333 31.1151 2 31.0568 1.4 30.6735C0.8 30.2901 0.5 29.7318 0.5 28.9985V19.9985L16.5 15.9985L0.5 11.9985V2.99848C0.5 2.26514 0.8 1.70681 1.4 1.32348C2 0.940144 2.63333 0.881811 3.3 1.14848L34.1 14.1485C34.9333 14.5151 35.35 15.1318 35.35 15.9985C35.35 16.8651 34.9333 17.4818 34.1 17.8485L3.3 30.8485Z",
    fill: "#467077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendToContentBlockIcon);
export default __webpack_public_path__ + "static/media/send-to-content-block-icon.0ef94fe6e0c292a881e24ad8857fab85.svg";
export { ForwardRef as ReactComponent };